import { Component, Input, OnInit } from '@angular/core';
@Component({
  selector: 'ui-loading-balls',
  templateUrl: './balls.component.html',
  standalone: false,
  styleUrls: ['./balls.component.scss']
})
export class BallsComponent implements OnInit {
  @Input() loading: boolean = false
  constructor() { }
  ngOnInit(): void {
  }
}
